import { Col, Form, Input, message, Modal, Row, Select } from "antd";
import { Rule } from "antd/lib/form";
import { projectApi } from "api/project.api";
import { scenarioApi } from "api/scenario.api";
import React, { useImperativeHandle, useState } from "react";
import { Project } from "types/project";
import "./ScenarioModal.scss";

const rules: Rule[] = [{ required: true }];

export interface ScenarioModal {
  handleCreate: () => void;
}

interface ScenarioModalProps {
  onClose?: () => void;
  onSubmitOk: () => void;
}

type ScenarioForm = {
  name: string;
  projectId: number;
};

export const ScenarioModal = React.forwardRef(({ onClose, onSubmitOk }: ScenarioModalProps, ref) => {
  const [form] = Form.useForm<ScenarioForm>();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [projects, setProjects] = useState<Project[]>([]);

  const fetchProject = async () => {
    const res = await projectApi.findAll({ page: 1, limit: 0 });
    setProjects(res.data.projects);
  };

  useImperativeHandle<any, ScenarioModal>(
    ref,
    () => ({
      handleCreate() {
        form.resetFields();
        setVisible(true);
        fetchProject();
      },
    }),
    [form],
  );

  const submitForm = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      await scenarioApi.create({
        projectId: values.projectId,
        name: values.name,
      });

      message.success("Tạo thành công!");
      onSubmitOk();
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose?.();
    setVisible(false);
  };

  return (
    <Modal
      onCancel={handleClose}
      open={visible}
      title="Tạo tình huống"
      style={{ top: 20 }}
      width={560}
      confirmLoading={loading}
      onOk={submitForm}
    >
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Tên tình huống" name="name" rules={rules}>
              <Input placeholder="Nhập tên tình huống" />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Dự án" name="projectId" rules={rules}>
              <Select placeholder="Chọn dự án" className="scenarioModalSelect">
                {projects?.map((project) => (
                  <Select.Option key={project.id} value={project.id}>
                    {project.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
});

ScenarioModal.displayName = "ScenarioModal";
